import {
  clinicDetailsPage,
  clinicDetailsSchema,
} from "./clinic-details.schema";
import {
  escalationConfigurationPage,
  escalationConfigurationSchema,
} from "./escalation-configuration.schema";
import { followUpsPage, followUpsSchema } from "./follow-ups.schema";
import {
  healthcareServiceSchema,
  servicesPage,
} from "./healthcare-service.schema";
import { koraConfigPage, koraConfigSchema } from "./kora-config.schema";
import { locationSchema, locationsPage } from "./location.schema";
import { practitionerSchema, practitionersPage } from "./practitioner.schema";

export {
  clinicDetailsPage,
  clinicDetailsSchema,
} from "./clinic-details.schema";
export {
  escalationConfigurationPage,
  escalationConfigurationSchema,
} from "./escalation-configuration.schema";
export { followUpsPage, followUpsSchema } from "./follow-ups.schema";
export {
  healthcareServiceSchema,
  servicesPage,
} from "./healthcare-service.schema";
export { koraConfigPage, koraConfigSchema } from "./kora-config.schema";
export { locationSchema, locationsPage } from "./location.schema";
export {
  memberPractitionerSchema,
  practitionerSchema,
  practitionersPage,
  schedulingPractitionerSchema,
} from "./practitioner.schema";

/**
 * Every Agent Configuration page with the schema it renders, in the order
 * the rail lists them.
 */
export const agentConfigurationPages = [
  { page: koraConfigPage, schema: koraConfigSchema },
  { page: followUpsPage, schema: followUpsSchema },
  {
    page: escalationConfigurationPage,
    schema: escalationConfigurationSchema,
  },
];

/**
 * The Clinic Configuration pages about the clinic itself, with the schema
 * each renders, in the order the rail lists them.
 */
export const clinicGeneralPages = [
  { page: clinicDetailsPage, schema: clinicDetailsSchema },
];

/**
 * The Clinic Configuration pages for the clinic's day-to-day operation, in
 * the order the rail lists them, after `clinicGeneralPages`.
 */
export const clinicOperationPages = [
  { page: practitionersPage, schema: practitionerSchema },
  { page: locationsPage, schema: locationSchema },
  { page: servicesPage, schema: healthcareServiceSchema },
];

/**
 * Every section stored on the clinic configuration `Basic`, whichever page
 * renders it.
 *
 * The pages split; the resource does not. One `Basic`, one `versionId`, one
 * patch — so anything that maps a section back to what is stored (its slug,
 * its field shape, whether it is an array) has to see all of them, not just
 * the page the edit came from. A page schema answers "what does this page
 * show"; this answers "what is on the resource".
 */
export const clinicConfigurationSchema = {
  ...koraConfigSchema.extensions,
  ...followUpsSchema.extensions,
  ...escalationConfigurationSchema.extensions,
} as const;
